<div class="auth-title-text">
  {{ authFlowTitle$ | async }}
</div>

<div class="auth-flow-subtext">
  {{ authFlowSubtext$ | async }}
</div>

<form [formGroup]="formGroup" class="d-flex flex-column gap-4 mb-4">
  <div class="d-flex flex-column gap-2">
    <label for="birthdate" class="form-input-label" i18n>Date of Birth</label>
    <app-date-input
      formControlName="birthdate"
      controlId="birthdate"
      [error]="formSubmitted && formGroup.controls.birthdate.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.birthdate.invalid"
      [customErrorMessages]="customErrorMessages.birthdate"
      [errors]="formGroup.controls.birthdate.errors" />
    <span class="form-input-hint" i18n>DD / MM / YYYY</span>
  </div>

  <div class="d-flex flex-column gap-2">
    <label for="sin" class="form-input-label" i18n>Last 3 Digits of Your SIN</label>
    <app-masked-text-input
      formControlName="sin"
      controlId="sin"
      placeholder="••• ••• 000"
      i18n-placeholder
      [maskOptions]="sinMaskOptions"
      (keydown.enter)="submit()"
      [error]="formSubmitted && formGroup.controls.sin.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.sin.invalid"
      [customErrorMessages]="customErrorMessages.sin"
      [errors]="formGroup.controls.sin.errors" />
  </div>
</form>

<div class="action-button-container">
  <app-primary-button [style.width.%]="100" [width]="'100%'" (buttonClicked)="submit()" i18n>
    Continue
  </app-primary-button>
</div>
<div class="member-support-button-container">
  <span i18n>Having trouble?</span>
  <button class="paddingless-text-button support-text mt-2" (click)="openContactPage()" i18n>
    Click here for support
  </button>
</div>
